@if (!compact) {
  <div class="flex flex-row items-center">
    <div class="shrink-0">
      <app-user-avatar
        class="mx-auto mr-1.5 shrink-0"
        [ngClass]="{ 'hidden sm:max-lg:block xl:block': !alwaysDisplayProfilePicture }"
        [name]="name"
        [size]="26"
        [systemUser]="systemUser"
      ></app-user-avatar>
    </div>
    <div class="flex flex-col">
      @if (!!name && !!userId && (permissions$ | async)?.includes('intranet_users_upsert')) {
        <div class="text-grey-mid" [tooltip]="userTooltip || 'Edit User'">
          <a
            id="user-link"
            class="font-medium inline-flex btn-link leading-tight"
            [routerLink]="'/users/edit/' + userId"
            (click)="clearUserFilters()"
            >{{ name }}</a
          >
        </div>
      } @else if (!!name) {
        <div class="font-medium">
          {{ name }}
        </div>
      }
      @if (!!date) {
        <span
          (click)="showFullDate = !showFullDate; $event.stopPropagation()"
          class="btn-link hover:text-primary w-fit inline-flex font-normal text-[.8em] mb-0.5 cursor-pointer"
          [tooltip]="dateTooltip || ''"
        >
          {{ showFullDate ? (date | amDateFormat: 'HH:mm &middot; D MMM YYYY') : (date | amTimeAgo) }}
        </span>
      }
    </div>
  </div>
} @else {
  <div class="flex text-xs font-normal">
    @if (!!name && !!userId && (permissions$ | async)?.includes('intranet_users_upsert')) {
      <div class="text-grey-mid btn-link" [tooltip]="userTooltip || 'Edit User'">
        <a [routerLink]="'/users/edit/' + userId" (click)="clearUserFilters()">{{ name }}</a>
      </div>
    } @else if (!!name) {
      <div>
        {{ name }}
      </div>
    }
    <span class="ml-2">&bull; &nbsp;{{ date | amDateFormat: 'D MMM YYYY h:mma' }}</span>
  </div>
}
